module.exports = __webpack_public_path__ + "img/wxcode.0e401ca3.jpeg";